// extracted by mini-css-extract-plugin
module.exports = {"essentialsItemsContainer":"EssentialsPanel_essentialsItemsContainer__EKmSN","basicItem":"EssentialsPanel_basicItem__bcDG7"};